import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Highlight } from '../Highlight';
import { bonos, bonosTotal } from '../../data/landing';
export function Bonos() {
  return <section id="bonos" className="scroll-mt-4 bg-white px-5 py-16 md:py-24" data-id="element-61" data-mp="1hj911h4nyec3">
      <div className="mx-auto max-w-5xl" data-id="element-62" data-mp="1clpnykjpc7lq">
        <SectionHeading eyebrow="Siempre incluidos" title={<>
              5 Bonos <Highlight data-id="element-64" data-mp="osqzwlni2n1b">estratégicos</Highlight>
            </>} data-id="element-63" data-mp="1cilaewkcjzie" />

        <ul className="mt-12 space-y-3" data-id="element-65" data-mp="jxtstk9s6nr2">
          {bonos.map(b => <li key={b.number} className="grid grid-cols-[auto_1fr] gap-4 rounded-2xl border border-gold/60 bg-gold-soft p-5 sm:grid-cols-[auto_1fr_auto] sm:items-center md:p-6" data-id="element-66" data-mp="yloo98f6b67u">
              <span className="flex h-14 w-14 flex-col items-center justify-center rounded-xl bg-gold text-brand" data-id="element-67" data-mp="62rh2gi9646c">
                <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-68" data-mp="13okzlk938ai" />
                <span className="text-xs font-black" data-id="element-69" data-mp="2z9mb8at4n2om">{b.number}</span>
              </span>
              <div data-id="element-70" data-mp="3487g4njbqaje">
                <p className="text-xs font-black uppercase tracking-wider text-brand/70" data-id="element-71" data-mp="347nxt5prhk4u">
                  Bono {Number(b.number)}
                </p>
                <p className="text-lg font-extrabold leading-tight text-brand" data-id="element-72" data-mp="3d2bzklw4ojow">{b.title}</p>
                <p className="mt-1 text-sm text-charcoal md:text-base" data-id="element-73" data-mp="2gbte5p56pmz5">{b.description}</p>
              </div>
              <div className="col-span-2 flex items-center justify-between gap-4 border-t border-gold/50 pt-3 sm:col-span-1 sm:flex-col sm:items-end sm:border-t-0 sm:pt-0" data-id="element-74" data-mp="2la4nzzvhbxhd">
                <span className="whitespace-nowrap text-sm text-muted" data-id="element-75" data-mp="2ubb3q6qb149k">
                  Valorado: <span className="line-through decoration-danger" data-id="element-76" data-mp="2u9854yb362t8">{b.value}</span>
                </span>
                <span className="rounded-full bg-brand px-3 py-1 text-sm font-black uppercase text-white" data-id="element-77" data-mp="4od5xqwmpaek">
                  Gratis
                </span>
              </div>
            </li>)}
        </ul>

        <div className="mt-8 flex flex-col items-center justify-between gap-2 rounded-2xl bg-brand px-6 py-5 text-center sm:flex-row sm:text-left" data-id="element-78" data-mp="21mn1caqu2c0v">
          <p className="text-lg text-white" data-id="element-79" data-mp="2fl36vycylwhf">
            Valor total bonos:{' '}
            <span className="font-black line-through decoration-gold decoration-2" data-id="element-80" data-mp="2aoctxjwgbh08">{bonosTotal}</span>
          </p>
          <p className="text-xl font-black uppercase text-gold" data-id="element-81" data-mp="1myifwz0ebmee">→ Gratis con tu MegaPack</p>
        </div>
      </div>
    </section>;
}